<nb-card class="c-body">
    <nb-card-header>
        <div class="header-container">
            <div class="header-content">
                <div class="header-title">
                    <nb-icon icon="calendar-outline" class="header-icon"></nb-icon>
                    <h3>Availability Management</h3>
                </div>
                <p class="header-subtitle">Manage your business hours and availability settings</p>
            </div>
            <div class="header-stats">
                <div class="stat-badge">
                    <nb-icon icon="clock-outline"></nb-icon>
                    <span>{{availability?.length || 0}} Schedule{{availability?.length !== 1 ? 's' : ''}}</span>
                </div>
            </div>
        </div>
    </nb-card-header>
    
    <nb-card-body>
        <div class="action-bar" *ngIf="availability?.length > 0">
            <button 
                nbButton 
                status="primary" 
                (click)="addNew()"
                class="add-button"
            >
                <nb-icon icon="plus-outline"></nb-icon>
                Add New Schedule
            </button>
        </div>

        <!-- Availability Cards -->
        <div class="availability-grid" *ngIf="availability?.length > 0">
            <div class="availability-card" *ngFor="let item of availability; index as i">
                <div class="card-header">
                    <div class="card-number">
                        <nb-icon icon="hash-outline"></nb-icon>
                        {{i + 1}}
                    </div>
                    <div class="card-actions">
                        <button 
                            nbButton 
                            ghost 
                            status="info" 
                            size="small"
                            (click)="edit(item, i)"
                            nbTooltip="Edit schedule"
                        >
                            <nb-icon icon="edit-2-outline"></nb-icon>
                        </button>
                        <button 
                            nbButton 
                            ghost 
                            status="danger" 
                            size="small"
                            (click)="remove(i)"
                            nbTooltip="Delete schedule"
                        >
                            <nb-icon icon="trash-2-outline"></nb-icon>
                        </button>
                    </div>
                </div>

                <div class="card-content">
                    <!-- Domain Section -->
                    <div class="info-section" *ngIf="item?.DM && item?.DM.length > 0">
                        <div class="section-label">
                            <nb-icon icon="globe-outline"></nb-icon>
                            <span>Domains</span>
                        </div>
                        <div class="tag-container">
                            <span class="tag tag-domain" *ngFor="let domain of item?.DM">
                                {{domain | camelCase}}
                            </span>
                        </div>
                    </div>

                    <!-- Days Section -->
                    <div class="info-section" *ngIf="item?.D && item?.D.length > 0">
                        <div class="section-label">
                            <nb-icon icon="calendar-outline"></nb-icon>
                            <span>Days</span>
                        </div>
                        <div class="tag-container">
                            <span class="tag tag-day" *ngFor="let day of item?.D">
                                {{getDay(day)}}
                            </span>
                        </div>
                    </div>

                    <!-- Hours/Timings Section -->
                    <div class="info-section" *ngIf="item?.H && item?.H.length > 0">
                        <div class="section-label">
                            <nb-icon icon="clock-outline"></nb-icon>
                            <span>Timings</span>
                        </div>
                        <div class="tag-container">
                            <span class="tag tag-time" *ngFor="let hour of item?.H">
                                <nb-icon icon="arrow-right-outline" class="time-arrow"></nb-icon>
                                {{convertTo12Hour(hour.S)}} - {{convertTo12Hour(hour.E)}}
                            </span>
                        </div>
                    </div>

                    <!-- Date Range Section -->
                    <div class="info-section date-range-section" *ngIf="item?.SD && item?.ED">
                        <div class="section-label">
                            <nb-icon icon="calendar-outline"></nb-icon>
                            <span>Date Range</span>
                        </div>
                        <div class="date-range-display">
                            <span class="date-badge">
                                <nb-icon icon="calendar-outline"></nb-icon>
                                {{formatDate(item.SD)}}
                            </span>
                            <nb-icon icon="arrow-forward-outline" class="date-arrow"></nb-icon>
                            <span class="date-badge">
                                <nb-icon icon="calendar-outline"></nb-icon>
                                {{formatDate(item.ED)}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="availability?.length === 0">
            <div class="empty-icon">
                <nb-icon icon="calendar-outline"></nb-icon>
            </div>
            <h4>No Availability Schedules</h4>
            <p>Get started by creating your first availability schedule</p>
            <button 
                nbButton 
                status="primary" 
                (click)="addNew()"
                class="empty-action-button"
            >
                <nb-icon icon="plus-outline"></nb-icon>
                Create Schedule
            </button>
        </div>

    </nb-card-body>
    
    <nb-card-footer>
        <div class="footer-actions">
            <button 
                nbButton 
                status="basic" 
                (click)="close(false)"
            >
                <nb-icon icon="close-outline"></nb-icon>
                Cancel
            </button>
            <button 
                nbButton 
                status="success" 
                (click)="save()"
            >
                <nb-icon icon="checkmark-outline"></nb-icon>
                Save Changes
            </button>
        </div>
    </nb-card-footer>
</nb-card>